import type { FC } from 'react';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import Header from './components/Header';
import Footer from './components/Footer';

const Layout: FC = ({ children }) => (
  <Container
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      alignItems: 'center',
      width: '100%',
      maxWidth: '100%',
      minWidth: '100%',
      p: '0 !important',
      bgcolor: 'background.base',
    }}
  >
    <Stack
      px={[1, 3, 4]}
      py={3}
      flexGrow={1}
      maxWidth={[1, undefined, undefined, 0.75]}
    >
      <Header />

      {children}

      <Footer />
    </Stack>
  </Container>
);

export default Layout;
